import http from '../_http'

const notice = {
  //default
  summaryNotice: (m) => { return http.get(`manager/board/notice`, m); },
  listNotice: (m) => { return http.post(`manager/board/notice/list`, m); },
  detailNotice: (m) => { return http.get(`manager/board/notice/${m.id}`); },

  //crud
  insertNotice: (m) => { return http.post(`manager/board/notice`, m); },
  updateNotice: (m) => { return http.put(`manager/board/notice`, m); },
  deleteNotice: (m) => { return http.delete(`manager/board/notice/${m.id}`); },
}

export default notice

export { notice }